<app-toaster></app-toaster>
<app-loader></app-loader>
<app-message-pop-up></app-message-pop-up>
<router-outlet></router-outlet>